import { FACEBOOK_PLATFORM, TIKTOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'

export const FACEBOOK_AND_TIKTOK = 'facebook_and_tiktok'

export const platformOptions = [
  {
    value: FACEBOOK_PLATFORM,
    label: 'Meta'
  },
  {
    value: TIKTOK_PLATFORM,
    label: 'TikTok'
  },
  {
    value: FACEBOOK_AND_TIKTOK,
    label: 'Meta and TikTok'
  }
]
